import { css, styled } from 'styled-components';

export const purpleGradientTextStyles = css`
  ${({ theme }) => css`
    // fallback to a solid colour if gradient background image isn't supported
    background-color: ${theme.colorsV2.brandPurple};
    background-image: linear-gradient(
      117.09deg,
      #222834 -28.29%,
      #6a57e3 67.55%,
      #cd74dd 96.23%
    );

    background-size: 100%;
    background-clip: text;
    // webkit and moz specific fallbacks
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    -moz-background-clip: text;
    -moz-text-fill-color: transparent;
  `}
`;

const disabledTextStyles = css`
  color: unset;
`;

export const PurpleGradientText = styled.span<{ disabled?: boolean }>`
  ${({ disabled }) =>
    disabled ? disabledTextStyles : purpleGradientTextStyles}
`;
